import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/shared/types/state';
import { User } from '@/shared/types/user';

export const selectUser = (state: RootState): User => state.user?.user ?? null;

export const selectUserId = (state: RootState) => state.user?.user?.user_id;

export const selectUserInvitation = (state: RootState) => state.user?.user?.invitation;

export const selectIsAuthenticated = createSelector([selectUser], (user) => Boolean(user?.user_id));

export const selectPendingInvitation = createSelector(
  [selectUser],
  (user: User) => user?.invitation
);

export const selectShouldShowOnboarding = createSelector(
  [selectUser],
  (user: User) => user?.metadata?.show_onboarding === true
);

export const selectShouldShowWelcome = createSelector(
  [selectUser],
  (user: User) => user?.metadata?.show_welcome === true
);

export const selectIsLoadingUser = (state: RootState) => {
  const { loading, error, loaded } = state.user?.loginStatus ?? {};

  if (!loading && !error && !loaded) {
    return false;
  }
  return loading || (!loaded && !error);
};

export const selectIframeView = (state: RootState) => {
  return state.user?.iframeView ?? false;
};
